"use strict";

import _ from "lodash";
import React, { Component, PropTypes } from "react";

const isEqual = _.isEqual;

/******************************************************************************
** ComponentBase
*/

export default class ComponentBase extends Component {

	constructor(props) {
		super(props);
		this.state = Object.assign(this.state || {}, {
			dimensions: {
				left: 0,
				top: 0,
				width: 0,
				height: 0
			}
		});
	}

	shouldComponentUpdate(nextProps, nextState) {
		return !isEqual(nextState, this.state)
			|| !isEqual(nextProps, this.props)
		;
	}

	componentDidMount() {
		if (typeof super.componentDidMount == "function")
			super.componentDidMount();
		this.resetDimensions();
	}

	componentDidUpdate() {
		if (typeof super.componentDidUpdate == "function")
			super.componentDidUpdate();
		this.resetDimensions();
	}

	resetDimensions() {
		let element = this.refs.topContainer;
		if (typeof element == "undefined") {
			console.warn(`Can't resolve ref with name 'topContainer' for component with name '${this.props.name}'.`);
			return;
		}
		let $e = $(element);
		let $left = $e.offset().left;
		let $top = $e.offset().top;
		let $width = $e.outerWidth();
		let $height = $e.outerHeight();
		if (this.state.dimensions.left !== $left
			|| this.state.dimensions.top !== $top
			|| this.state.dimensions.width !== $width
			|| this.state.dimensions.height !== $height
		) {
			this.setState({
				dimensions: {
					left: $left,
					top: $top,
					width: $width,
					height: $height
				}
			});
		}
	}

}



/** WEBPACK FOOTER **
 ** ./forms/ComponentBase.jsx
 **/